

module.exports = __webpack_require__.stylable.create(
    "TotalsSectionOverride3827481866",
    {"classes":{"root":"TotalsSectionOverride3827481866__root","mySummeryDivider":"TotalsSectionOverride3827481866__mySummeryDivider","myTotalRow":"TotalsSectionOverride3827481866__myTotalRow","mySubtotalRow":"TotalsSectionOverride3827481866__mySubtotalRow"},"vars":{},"stVars":{"dividerMainColor":"'\"color(--thankYou_dividersColor)\"'","dividerMainWidth":"1","totalRowTextColor":"'\"color(--thankYou_titleColor)\"'","totalRowTextFont":"'\"font({theme: 'thankYou_titleFontStyle', size: '20px', lineHeight: '28px'})\"'","totalsTextColor":"'\"color(--thankYou_textColor)\"'","totalsTextFont":"'\"font({theme: 'thankYou_textFontStyle', size: '14px', lineHeight: '20px'})\"'","totalRowValueTextFont":"'\"font({theme: 'thankYou_textFontStyle', size: '20px', lineHeight: '28px'})\"'"},"keyframes":{}},
    "",
    14,
    "TotalsSectionOverride3827481866",
    null
);
